export default {"src":"/_next/static/media/san-marino.a51151ad.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};